import { IBasketballStageApi } from '../types';
import Core from '@mediaplatform/basketball-sdk';

export default (sdk: Core): IBasketballStageApi => {
  const getStage: IBasketballStageApi['getStage'] = (stageId) => {
    if (stageId) {
      const stage = sdk.stage(stageId.toString());

      return stage.withRules().get();
    }
    console.warn('No stage id provided');
  };
  return { getStage };
};
